import Container from '../Container';
import LogoutButton from '../LogoutButton';
import './Header.css';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
	const name = localStorage.name;
	const location = useLocation();
	const getNavButtonClasses = (path) => {
		const baseClasses = 'p-2 rounded-md font-semibold';
		const isActive = location.pathname === path;
		const activeClasses = 'bg-[#04ad89] text-white';
		const inactiveClasses = 'bg-white text-[#1b2831]';
		return `${baseClasses} ${isActive ? activeClasses : inactiveClasses}`;
	};

	return (
		<header>
			<Container>
				<div className=' h-[100px] bg-[#1b2831] text-white flex justify-between items-center'>
					<h2>Welcome, {name}</h2>

					<div className='btns'>
						<div className='nav flex gap-x-4 '>
							<Link to={'/admin'}>
								<button className={getNavButtonClasses('/admin')}>
									Add Olib
								</button>
							</Link>
							<Link to={'/assign-resources'}>
								<button className={getNavButtonClasses('/assign-resources')}>
									Assign resources
								</button>
							</Link>
							<Link to={'/news'}>
								<button className={getNavButtonClasses('/news')}>News</button>
							</Link>
							<LogoutButton />
						</div>
					</div>
				</div>
			</Container>
		</header>
	);
};

export default Header;
